export default __webpack_public_path__ + "static/lt_white_logo-1a45a3710ea44b9144c0c280f3475634.webp";